import React from "react"

const NAVY = "#221C5D"

/**
 * Abonelik kilit kartı — hem SubscriptionGate (EXPIRED route bloğu) hem
 * SubscriptionExpiredOverlay (402 / limit aşımı) tarafından kullanılan
 * ortak görsel bileşen. Sadece sunum; yönlendirmeyi parent yapar.
 */
const SubscriptionLockedCard = ({ content, onPrimary, onSecondary, onClose }) => (
  <div
    style={{
      position: "relative",
      backgroundColor: "#fff",
      borderRadius: "1rem",
      padding: "3rem 2.5rem",
      maxWidth: 480,
      width: "100%",
      textAlign: "center",
      boxShadow: "0 1rem 3rem rgba(0,0,0,.25)",
    }}
  >
    {onClose && (
      <button
        type="button"
        className="btn-close"
        aria-label="Kapat"
        onClick={onClose}
        style={{ position: "absolute", top: "1rem", right: "1rem" }}
      />
    )}

    <div style={{ marginBottom: "1.5rem" }}>
      <i className={`bx ${content.icon}`} style={{ fontSize: 64, color: "#dc3545" }} />
    </div>

    <h4 className="fw-bold mb-2" style={{ color: "#333" }}>
      {content.title}
    </h4>
    <p className="text-muted mb-4" style={{ fontSize: 15 }}>
      {content.message}
    </p>

    <button
      className="btn btn-lg w-100 mb-3"
      style={{
        backgroundColor: NAVY,
        borderColor: NAVY,
        color: "#fff",
        borderRadius: 999,
        fontWeight: 600,
      }}
      onClick={onPrimary}
    >
      <i className="bx bx-cart me-2" />
      {content.cta}
    </button>

    <button
      className="btn btn-outline-secondary btn-sm"
      style={{ borderRadius: 999 }}
      onClick={onSecondary}
    >
      Abonelik Geçmişim
    </button>
  </div>
)

export default SubscriptionLockedCard
